<template>
    <div class="inquiry-school">
        <el-table
            :data="tableData"
            style="width: 100%;border: 2px solid #F0F6F9"
            :header-cell-style="{color:'black', fontSize:'15px', fontFamily:'MicrosoftYaHeiUI'}"
            :row-style="{fontSize:'14px', fontFamily:'MicrosoftYaHeiUI'}">
            
        <el-table-column
                label="院校名称"
                width="200px">
                <template slot-scope="scope">
                     <el-link type="text">{{scope.row.schoolName}}</el-link>
                </template>
        </el-table-column>
        <el-table-column
                prop="schoolLoc"
                label="院校所在地"
                width="110px">
        </el-table-column>
        <el-table-column
                prop="schoolDepart"
                label="教育行政主管部门"
                width="200px">
        </el-table-column>
        <el-table-column
                prop="schoolType"
                label="院校类型"
                width="90px">
        </el-table-column>
        <el-table-column
                prop="learnType"
                label="学历层次"
                width="140px">
        </el-table-column>
        <el-table-column
                label="一流大学建设高校"
                width="90px"
                align="center">
                <template slot-scope="scope">
                     <i v-if="scope.row.TopUniversity" class="el-icon-check"></i>
                </template>
        </el-table-column>	


        <el-table-column
                label="一流学科建设高校"
                width="90px"
                align="center">
                <template slot-scope="scope">
                     <i v-if="scope.row.TopAcademic" class="el-icon-check"></i>
                </template>
        </el-table-column>
        <el-table-column
                label="研究生院"
                width="90px"
                align="center">
               <template slot-scope="scope">
                     <i v-if="scope.row.graduateClass" class="el-icon-check"></i>
                </template>
        </el-table-column>
        <el-table-column
                prop="satisfaction"
                label="满意度"
                align="center">
        </el-table-column>
        </el-table>

        <div class="block">
            <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="10"
            layout="prev, pager, next, jumper"
            :total="50">
            </el-pagination>
        </div>
    </div>
</template>

<script>		
export default {
      data() {
        return {
          currentPage: 1,
          flag: 'true',
          tableData: [
          {
            schoolName: '北京大学',
            schoolLoc: '北京',
            schoolDepart: '教育部',
            schoolType: '综合',
            learnType: '本科',
            TopUniversity: true,
            TopAcademic: false,
            graduateClass: true,
            satisfaction: '4.7'
          }, {
           schoolName: '中国人民大学',
            schoolLoc: '北京',
            schoolDepart: '教育部',
            schoolType: '综合',
            learnType: '本科',
            TopUniversity: true,
            TopAcademic: false,
            graduateClass: true,
            satisfaction: '4.7'
          }, {
            schoolName: '清华大学',
            schoolLoc: '北京',
            schoolDepart: '教育部',
            schoolType: '综合',
            learnType: '本科',
            TopUniversity: true,
            TopAcademic: false,
            graduateClass: true,
            satisfaction: '4.8'
          }, {
            schoolName: '北京交通大学',
            schoolLoc: '北京',
            schoolDepart: '教育部',
            schoolType: '工科',
            learnType: '本科/高职(专科)',
            TopUniversity: false,
            TopAcademic: true,
            graduateClass: true,
            satisfaction: '4.4'
          },
          {
            schoolName: '北京工业大学',
            schoolLoc: '北京',
            schoolDepart: '背景市教育委员会',
            schoolType: '工科',
            learnType: '本科/高职(专科)',
            TopUniversity: false,
            TopAcademic: true,
            graduateClass: false,
            satisfaction: '4.3'
          },
          {
            schoolName: '北京航空航天大学',
            schoolLoc: '北京',
            schoolDepart: '工业和信息化部',
            schoolType: '工科',
            learnType: '本科',
            TopUniversity: true,
            TopAcademic: false,
            graduateClass: true,
            satisfaction: '4.4'
          },
          {
            schoolName: '北京理工大学',
            schoolLoc: '北京',
            schoolDepart: '工业和信息化部',
            schoolType: '工科',
            learnType: '本科',
            TopUniversity: true,
            TopAcademic: false,
            graduateClass: true,
            satisfaction: '4.5'
          },
          {
            schoolName: '北京科技大学',
            schoolLoc: '北京',
            schoolDepart: '教育部',
            schoolType: '工科',
            learnType: '本科/高职(专科)',
            TopUniversity: false,
            TopAcademic: true,
            graduateClass: true,
            satisfaction: '4.5'
          }
        ]
        }
      },
      methods:{
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
        }
      }
    }
</script>

<style scoped>
.el-pagination {
    text-align: right;
}

.block{
    margin-top: 12px;
}
</style>